import PropTypes from "prop-types";

/**
 * @typedef {Object} StarItem
 * @property {number} id
 * @property {boolean} isFilled
 */

/**
 * @typedef {Object} CreatorTestimonialData
 * @property {string} [badge]
 * @property {string} [authorName]
 * @property {string} [companyName]
 * @property {string} [role]
 * @property {string} [subtitle]
 * @property {string} [rating]
 * @property {number} [maxStars]
 * @property {string} [quote]
 * @property {string} [photoUrl]
 * @property {string} [photoPlaceholderText]
 */

export const TESTIMONIAL_SHAPE = PropTypes.shape({
  badge: PropTypes.string,
  authorName: PropTypes.string,
  companyName: PropTypes.string,
  role: PropTypes.string,
  subtitle: PropTypes.string,
  rating: PropTypes.string,
  maxStars: PropTypes.number,
  quote: PropTypes.string,
  photoUrl: PropTypes.string,
  photoPlaceholderText: PropTypes.string,
});

export const CREATOR_TESTIMONIAL_PROPS = {
  id: PropTypes.string,
  testimonial: TESTIMONIAL_SHAPE,
  containerClassName: PropTypes.string,
  cardClassName: PropTypes.string,
};
